(() => {
  const configNode = document.getElementById('ns-black-week-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const startsAt = Date.parse(config.startsAt);
  const endsAt = Date.parse(config.endsAt);
  const active = () => config.enabled === true && Date.now() >= startsAt && Date.now() < endsAt;
  const valid = amount => Number.isSafeInteger(amount) && amount >= 0;
  const format = amount => new Intl.NumberFormat(config.locale, {style: 'currency', currency: config.currency}).format(amount / 100);
  const node = (tag, className, text) => {
    const element = document.createElement(tag);
    element.className = className;
    element.textContent = text;
    return element;
  };
  const badge = () => active() ? node('span', 'ns-bw-action', config.promotion) : null;
  function url(path) {
    if (!window.location || !config.previewThemeId || !window.location.hostname.endsWith('.myshopify.com')) return path;
    const target = new URL(path, window.location.origin);
    if (target.origin !== window.location.origin) return path;
    target.searchParams.set('preview_theme_id', String(config.previewThemeId));
    target.searchParams.set('_fd', '0');
    return target.pathname + target.search;
  }
  function render(container, originalCents, options = {}) {
    if (!container) return;
    if (!valid(originalCents)) { container.replaceChildren(document.createTextNode('—')); return; }
    const hasFinal = Object.prototype.hasOwnProperty.call(options, 'finalCents');
    if (hasFinal && !valid(options.finalCents)) { container.replaceChildren(document.createTextNode('—')); return; }
    const campaign = hasFinal ? options.isBlackWeek === true : active();
    const finalCents = hasFinal ? options.finalCents : campaign ? Math.round(originalCents * 0.8) : originalCents;
    const sale = finalCents < originalCents;
    const group = node('span', 'ns-bw-price' + (sale ? ' ns-bw-price--sale' : '') + (options.compact ? ' ns-bw-price--compact' : ''), '');
    if (options.from) group.append(node('span', 'ns-bw-price__from', config.from));
    if (sale) {
      const original = node('s', 'ns-bw-price__original', format(originalCents));
      original.setAttribute('aria-label', config.original + ': ' + format(originalCents));
      group.append(original);
    }
    if (campaign) group.append(node('span', 'ns-bw-price__badge', config.label));
    const current = node('strong', 'ns-bw-price__current', format(finalCents));
    if (sale) current.setAttribute('aria-label', config.sale + ': ' + format(finalCents));
    group.append(current);
    container.replaceChildren(group);
  }
  window.NSBlackWeek = Object.freeze({active, badge, render, url});
})();
